// @flow
// $FlowFixMe
import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { X } from '@finect/tabular-icons/x';
import { getFont } from '@finect/tabular-utils/getFont';
import { slugify } from '@finect/front-utils/slugify';
import type { TagType } from '../../types';

export const Tags = styled.div`
  margin-left: -3px;
  ${({ isPreview }) => (isPreview ? ` margin-bottom: 6px;` : 'padding-top: 6px;')};
`;

const followedStyles = css`
  background-color: ${({ theme }) => theme.colors.accent1M};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;

  &:hover {
    background-color: ${({ theme }) => theme.colors.accent1D};
  }
`;

const TagBlock = styled.div`
  display: inline-block;
  position: relative;
  padding: 1px 9px 2px;
  border-radius: 4px;
  margin: 3px;
  cursor: pointer;
  background: #e8f2fe;
  ${getFont(-1, 'compact')};
  font-variant: small-caps;
  color: #1785fb;
  text-transform: lowercase;
  transition: all 0.15 ease;

  svg {
    cursor: pointer;
  }
`;

const DeleteIcon = styled.span`
  position: relative;
  top: 3px;
  left: 4px;
  opacity: 0.8;
  color: ${({ theme }) => theme.colors.fontL};
  transition: all 0.15s ease;

  &:hover {
    opacity: 1;
    color: ${({ theme }) => theme.colors.negative};
  }
`;

// TODO Remove hardcoded colors
const TagLink = styled(TagBlock)`
  &:hover {
    background-color: #1785fb;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #fff;
  }

  ${({ followed }) => followed && followedStyles};
`;

type Props = {
  tag: TagType,
  handleDelete?: Function,
  followed?: boolean
};

export const Tag = ({ tag, handleDelete, followed }: Props) => {
  const handleClick = () => {
    handleDelete && handleDelete(tag.id);
  };
  const topicURL = `https://${process.env.FINECT_BASEURL || 'www.finect.com'}/preguntas/temas/${tag.id}/${slugify(
    tag.name
  )}`;

  return (
    <Fragment>
      {handleDelete ? (
        <TagBlock>
          {tag.name}
          <DeleteIcon onClick={handleClick}>
            <X size="14" strokeWidth="2.6" />
          </DeleteIcon>
        </TagBlock>
      ) : (
        <TagLink as="a" followed={followed} rel="nofollow" href={topicURL}>
          {tag.name}
        </TagLink>
      )}
    </Fragment>
  );
};
